module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/course-calendar.json
// module id = 1875
// module chunks = 45564757907734